/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { LanguageRounded, LinkedIn, PagesOutlined, Telegram, WhatsApp } from '@mui/icons-material'
import { Link } from 'react-router-dom'

export default function Footer({ handleClick }) {
  
  const redirect = (link) => {
    window.open(link, "_blank");
  }
  return (

    <footer  style={{borderTop:"1px solid #1e293b"}} className="relative isolate overflow-hidden bg-gray-900 py-16 sm:py-24 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-96 gap-y-16 lg:max-w-none lg:grid-cols-2">
          <div className="max-w-xl lg:max-w-lg">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">Find us on</h2>
            <p className="mt-4 text-lg flex gap-4 leading-8 text-gray-300">
                <WhatsApp className='cursor-pointer hover:opacity-20' onClick={() => {redirect("https://api.whatsapp.com/send/?phone=%2B212669151094&text&type=phone_number&app_absent=0")}} />
                <LinkedIn className='cursor-pointer hover:opacity-20' onClick={() => {redirect("https://www.linkedin.com/company/goleador-sport-consulting/")}} />
                <Telegram className='cursor-pointer hover:opacity-20' onClick={() => {redirect("https://t.me/Mehdigsc")}} />
            </p>
            <p className='text-gray-200 font-family-poppins text-md mt-4'>
                Connect with us today and let's discuss exclusive offers tailored just for you! . 🌟
            </p>
            {/* <div className="mt-6 flex max-w-md gap-x-4">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                placeholder="Enter your email"
              />
              <button
                type="submit"
                className="flex-none rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                Subscribe
              </button>
            </div> */}
          </div>
          <dl className="grid grid-cols-2 font-family-poppins gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2">
            <div className="flex flex-col items-start">
                <div className="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                  <PagesOutlined className="h-6 w-6 text-white" aria-hidden="true" />
                </div>
                <dt className="mt-4 font-semibold text-white">Pages</dt>
                <dd className="mt-2 leading-7 text-gray-400">
                    <ul>
                        <Link onClick={(e)=>{
                            window.scrollTo(0, 0);
                            handleClick(e.currentTarget.href);
                        }} className='hover:text-gray-300' to={"gallery"}><li>Gallery</li></Link>
                        <Link onClick={(e)=>{
                            window.scrollTo(0, 0);
                            handleClick(e.currentTarget.href);
                        }} className='hover:text-gray-300' to={"about-us"}><li>About Us</li></Link>
                        <Link onClick={(e)=>{
                            window.scrollTo(0, 0);
                            handleClick(e.currentTarget.href);
                        }} className='hover:text-gray-300' to={"contact-us"}><li>Contact Us</li></Link>
                    </ul>
                  </dd>
            </div>
          </dl>
        </div>
      </div>
      <div className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6" aria-hidden="true">
        <div
          className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
        />
      </div>
    </footer>
  )
}
